import React from "react";
import HomeTestimonials from "../../beranda/Testimonials";

const TestimonialsProduct1 = () => {
  return <HomeTestimonials />;
};

export default TestimonialsProduct1;
